import advantagesIcon1 from './images/advantages/icon-1.svg';
import advantagesIcon2 from './images/advantages/icon-2.svg';
import advantagesIcon3 from './images/advantages/icon-3.svg';
import advantagesIcon4 from './images/advantages/icon-4.svg';

const advantages = [
  {
    icon: advantagesIcon1,
    text: 'Increase your conversions, sales and average basket sizes',
  },
  {
    icon: advantagesIcon2,
    text: 'Reduce customer returns',
  },
  {
    icon: advantagesIcon3,
    text: 'Reduce your carbon footprint',
  },
  {
    icon: advantagesIcon4,
    text: 'Insightful data (size and behavioural analytics)',
  },
];

export default advantages;
